import { render, staticRenderFns } from "./list-page.vue?vue&type=template&id=b0716a1c&scoped=true&"
import script from "./list-page.vue?vue&type=script&lang=js&"
export * from "./list-page.vue?vue&type=script&lang=js&"
import style0 from "./list-page.vue?vue&type=style&index=0&id=b0716a1c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0716a1c",
  null
  
)

export default component.exports